import type { VNode } from "vue";
import Vue from "vue";
import ColumnFilterComponent from "@/components/controls/grid/columnfilters/ColumnFilterComponent.vue";
import type { CreateElement } from "vue/types/vue";
import type {
  FilterFunc,
  FilterState,
  FilterType,
} from "@/components/controls/grid/columnfilters/ColumnFilters";
import { buildApplyFilter } from "@/components/controls/grid/columnfilters/ColumnFilters";
import BmEnumDdl from "@/components/controls/input/BmEnumDdl.vue";
import type BaseEnumType from "@/app/services/baseEnumType";
import { translate } from "@/plugins/i18n";
import Key from "@/app/types/common/key";

const enumFilterTypes: FilterType[] = [
  {
    type: "filter_equals",
    values: 1,
    applyFunc: (
      itemValue: any,
      formattedItemValue: any,
      filterValue: BaseEnumType
    ) => {
      // We have to get the translated value, as that's what's used on the enum.
      const enumTranslatedValue = translate(
        Key.fromString(filterValue.translationKey!)
      );

      return itemValue === enumTranslatedValue;
    },
  },
  {
    type: "filter_not_equals",
    values: 1,
    applyFunc: (
      itemValue: any,
      formattedItemValue: any,
      filterValue: BaseEnumType
    ) => {
      // We have to get the translated value, as that's what's used on the enum.
      const enumTranslatedValue = translate(
        Key.fromString(filterValue.translationKey!)
      );

      return itemValue !== enumTranslatedValue;
    },
  },
];

export function buildApplyEnumFilter(state: FilterState): FilterFunc {
  return buildApplyFilter(state, enumFilterTypes);
}

export default Vue.extend({
  name: "EnumFilterComponent",
  components: { ColumnFilterComponent },
  render(createElement: CreateElement): VNode {
    return createElement(ColumnFilterComponent, {
      attrs: { ...this.$attrs },
      props: { filterTypes: enumFilterTypes },
      scopedSlots: {
        control1: function (props: any) {
          return createElement(BmEnumDdl, {
            attrs: {
              clearable: true,
            },
            props: {
              value: props.value ? (props.value as BaseEnumType) : null,
              enumType: props.columnConfig.enumType,
              enumFilter: props.columnConfig.enumFilter,
              hideZero: !props.columnConfig.showZeros,
            },
            on: {
              input: function (event: BaseEnumType) {
                props.setValue(event ?? ""); // ISO-8601
              },
            },
          });
        },
        control2: function (props: any) {
          return createElement(BmEnumDdl, {
            attrs: {
              clearable: true,
            },
            props: {
              value: props.value ? (props.value as BaseEnumType) : null,
              enumType: props.columnConfig.enumType,
              enumFilter: props.columnConfig.enumFilter,
              hideZero: !props.columnConfig.showZeros,
            },
            on: {
              input: function (event: BaseEnumType) {
                props.setValue(event ?? ""); // ISO-8601
              },
            },
          });
        },
      },
    });
  },
});
